export const LEAD_STATUS = {
  New: { label: 'New', color: 'b-blue' },
  Contacted: { label: 'Contacted', color: 'b-teal' },
  FollowUpPending: { label: 'Follow-up', color: 'b-amber' },
  Qualified: { label: 'Qualified', color: 'b-green' },
  ConsultationScheduled: { label: 'Moved to Consultation', color: 'b-purple' },
  NoShow: { label: 'No-show', color: 'b-orange' },
  ConsultationCompleted: { label: 'Consult Done', color: 'b-blue' },
  TreatmentStarted: { label: 'Treatment Started', color: 'b-green' },
  ConvertedPatient: { label: 'Converted', color: 'b-green' },
  ClosedLost: { label: 'Closed Lost', color: 'b-gray' },
  JunkLead: { label: 'Junk', color: 'b-red' },
  NotConnected: { label: 'Not Connected', color: 'b-orange' },
  NotConverted: { label: 'Not Converted', color: 'b-gray' },
  OutOfRadius: { label: 'Out of Radius', color: 'b-gray' }, // legacy rows only — no longer offered as an action
};

// Active pipeline: New → Not Connected / Follow-up / Move to Consultation / Junk,
// plus Not Converted (worked but didn't convert). ("Connected" was removed.)
export const LEAD_CORE_STATUSES = ['NotConnected', 'FollowUpPending', 'ConsultationScheduled', 'NotConverted', 'JunkLead'];
// Actions offered on an untouched (New) lead.
export const LEAD_ACTIONS_NEW = ['NotConnected', 'FollowUpPending', 'ConsultationScheduled', 'NotConverted', 'JunkLead'];
// Actions offered on a lead already in Follow-up (no "Follow-up" again).
export const LEAD_ACTIONS_FOLLOWUP = ['NotConnected', 'ConsultationScheduled', 'NotConverted', 'JunkLead'];

// Clinic departments for lead categorization + the global department filter.
export const LEAD_DEPARTMENTS = ['Physiotherapy', 'Home Visit', 'Functional', 'Total Transformation'];

export const LEAD_PRIORITY = {
  Hot:  { label: 'Hot',  color: 'b-red' },
  Warm: { label: 'Warm', color: 'b-amber' },
  Cold: { label: 'Cold', color: 'b-blue' },
};

export const PATIENT_STATUS = {
  ActiveTreatment: { label: 'Active', color: 'b-green' },
  Recovering: { label: 'Recovering', color: 'b-blue' },
  OnHold: { label: 'On Hold', color: 'b-amber' },
  Completed: { label: 'Completed', color: 'b-teal' },
  Dropped: { label: 'Dropped', color: 'b-red' },
  Referred: { label: 'Referred', color: 'b-purple' },
};

export const CONSULTATION_STATUS = {
  Scheduled: { label: 'Scheduled', color: 'b-blue' },
  Confirmed: { label: 'Confirmed', color: 'b-teal' },
  Completed: { label: 'Completed', color: 'b-green' },
  Cancelled: { label: 'Cancelled', color: 'b-gray' },
  NoShow: { label: 'No-show', color: 'b-red' },
  Rescheduled: { label: 'Rescheduled', color: 'b-amber' },
};

// Funnel-facing outcome shown as the editable "Status" dropdown on the Consultations dashboard —
// distinct from CONSULTATION_STATUS (the scheduling/calendar lifecycle, shown via row actions).
export const CONSULTATION_STAGE = {
  Scheduled: { label: 'Scheduled', color: 'b-blue' },
  OnlyConsultation: { label: 'Only Consultation', color: 'b-amber' },
  Converted: { label: 'Converted', color: 'b-green' },
  NoShow: { label: 'No show', color: 'b-red' },
  Cancelled: { label: 'Cancelled', color: 'b-gray' },
};

export const SESSION_STATUS = {
  Scheduled: { label: 'Scheduled', color: 'b-blue' },
  InProgress: { label: 'In Progress', color: 'b-amber' },
  Completed: { label: 'Completed', color: 'b-green' },
  Cancelled: { label: 'Cancelled', color: 'b-gray' },
  NoShow: { label: 'No-show', color: 'b-red' },
};

export const APPOINTMENT_STATUS = {
  Scheduled: { label: 'Scheduled', color: 'b-blue' },
  Confirmed: { label: 'Confirmed', color: 'b-teal' },
  InProgress: { label: 'In Progress', color: 'b-amber' },
  Completed: { label: 'Completed', color: 'b-green' },
  Cancelled: { label: 'Cancelled', color: 'b-gray' },
  NoShow: { label: 'No-show', color: 'b-red' },
  Rescheduled: { label: 'Rescheduled', color: 'b-amber' },
};

export const LEAD_SOURCES = [
  'MetaAds', 'InstagramAds', 'Facebook', 'GoogleAds', 'WebsiteForm', 'WhatsApp',
  'WalkIn', 'PhoneCall', 'Referral', 'QRCode', 'OfflineCamp', 'Other',
];
